import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { ConfirmLoadingButton } from '../../common/ConfirmLoadingButton';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const ConfirmLoadingButtonWidget = () => {
    const [loading, setLoading] = useState(false);
    const component = useMemo(() => (_jsx(ConfirmLoadingButton, { variant: "outlined", confirmMessage: "Confirmation message", loading: loading, onConfirm: () => {
            // do your actual action here
            setLoading(true);
            setTimeout(() => setLoading(false), 2000);
        }, children: "Action" })), [loading]);
    return {
        name: 'ConfirmLoadingButton',
        category: 'common',
        component,
    };
};
